import { createClient, mountUrl, MountGuard } from '@locaweb/lw-http-client'
import { snakelizeParams, camelizeResponseData } from './utils'
import { apiLogoutUrl } from '@/router/utils/logout'

const httpClient = createClient({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  authorizationCookieName: process.env.VUE_APP_COOKIE_NAME,
  logoutURL: apiLogoutUrl
})

httpClient.interceptors.request.use(snakelizeParams)
httpClient.interceptors.response.use(camelizeResponseData)

export { httpClient, mountUrl, MountGuard }
